import LTR from "@brand-icons/global/star-shinning/star-shinning-ltr.svg";

import { iconFactory } from "../iconFactory";

export const StarShinningIcon = iconFactory("StarShinningIcon", LTR);
